<template>
  <container class="my-4">
    <div
      class="mb-6 mt-6 md:mt-6"
      data-test="alert-block"
      :data-test-alert="dataTest"
    >
      <icon :icon="icon" size="medium" />
      <ui-title type="h2" class="mt-4 md:mt-0">
        {{ title }}
      </ui-title>
      <p class="mb-6">
        {{ description }}
      </p>
    </div>
  </container>
</template>
<script>
import { Container } from '~/components/grid'
import { UiTitle, Icon } from '~/components/atoms'

export default {
  components: {
    Container,
    UiTitle,
    Icon,
  },
  props: {
    icon: {
      type: String,
      default: 'info',
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    dataTest: {
      type: String,
      default: '',
    },
  },
}
</script>
